import script from "./CommunityTalk.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommunityTalk.vue?vue&type=script&setup=true&lang=ts"

import "./CommunityTalk.vue?vue&type=style&index=0&id=205b80dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-205b80dc"]])

export default __exports__